// https://fettblog.eu/typescript-react-generic-forward-refs/
import {
  forwardRef as _forwardRef,
  type Ref,
  type ReactElement,
  type RefAttributes,
} from "react";

export type ForwardRefFn = <T, P = object>(
  render: (props: P, ref: Ref<T>) => ReactElement | null
) => (props: P & RefAttributes<T>) => ReactElement | null;

export const forwardRef = _forwardRef as ForwardRefFn;
